import type { BillingCycleType } from "@/types";

/** "Every month", "Every 3 months", … */
export function formatBillingCycle(type: BillingCycleType, value: number): string {
  const cycles = {
    day: value === 1 ? "day" : "days",
    week: value === 1 ? "week" : "weeks",
    month: value === 1 ? "month" : "months",
    year: value === 1 ? "year" : "years",
  };

  return `Every ${value === 1 ? "" : `${value} `}${cycles[type]}`;
}
